export const GIFLoaderComponentType = 'mp.GIFLoaderComponent';
export const gltfLoaderComponentType = 'mp.gltfLoaderComponent';
export const imageComponentType = 'mp.imageComponent';
export const polygonComponentType = 'treedis.polygonComponent';
export const shadowComponentType = 'mp.shadowComponent';
export const UPNGLoaderComponentType = 'mp.UPNGLoaderComponent';
export const videoButtonType = 'treedis.videoButton';
